import styled from '@emotion/styled';

const Wrapper = styled('div')`
  padding: 20px;
  // styles for multi-level numbered list
  ol {
    list-style: none;
    counter-reset: li;
  }
  li:before {
    counter-increment: li;
    content: counters(li, '.') '. ';
  }
`;

const Header = styled('h1')`
  width: 100%;
  text-align: center;
  font-size: 18px;
`;

export const PrivacyPolicyPage = () => {
    return (
        <Wrapper>
            <Header>Политика в отношении обработки персональных данных</Header>
            <ol>
                <li>Общие положения</li>
                <br />
                <ol>
                    <li>
                        Настоящая политика обработки персональных данных составлена в
                        соответствии с требованиями Федерального закона от 27.07.2006. №
                        152-ФЗ «О персональных данных» (далее — Закон о персональных данных)
                        и определяет порядок обработки персональных данных и меры по
                        обеспечению безопасности персональных данных, предпринимаемые АО
                        "НЕЙРОСЕТИ" (ОГРН 119774673055) (далее — Оператор).
                    </li>
                    <li>
                        Оператор ставит своей важнейшей целью и условием осуществления своей
                        деятельности соблюдение прав и свобод человека и гражданина при
                        обработке его персональных данных, в том числе защиты прав на
                        неприкосновенность частной жизни, личную и семейную тайну.
                    </li>
                    <li>
                        Настоящая политика Оператора в отношении обработки персональных
                        данных (далее — Политика) применяется ко всей информации, которую
                        Оператор может получить о посетителях веб-сайта{' '}
                        <a target="_blank" href="https://neuroplai.ru">
                            https://neuroplai.ru
                        </a>
                        .
                    </li>
                </ol>
                <br />
                <li>Основные понятия, используемые в Политике</li>
                <br />
                <ol>
                    <li>
                        Автоматизированная обработка персональных данных — обработка
                        персональных данных с помощью средств вычислительной техники.
                    </li>
                    <li>
                        Блокирование персональных данных — временное прекращение обработки
                        персональных данных (за исключением случаев, если обработка
                        необходима для уточнения персональных данных).
                    </li>
                    <li>
                        Веб-сайт — совокупность графических и информационных материалов, а
                        также программ для ЭВМ и баз данных, обеспечивающих их доступность в
                        сети интернет по сетевому адресу{' '}
                        <a target="_blank" href="https://neuroplai.ru">
                            https://neuroplai.ru
                        </a>{' '}
                        .
                    </li>
                    <li>
                        Информационная система персональных данных — совокупность
                        содержащихся в базах данных персональных данных и обеспечивающих их
                        обработку информационных технологий и технических средств.
                    </li>
                    <li>
                        Обезличивание персональных данных — действия, в результате которых
                        невозможно определить без использования дополнительной информации
                        принадлежность персональных данных конкретному Пользователю или
                        иному субъекту персональных данных.
                    </li>
                    <li>
                        Обработка персональных данных — любое действие (операция) или
                        совокупность действий (операций), совершаемых с использованием
                        средств автоматизации или без использования таких средств с
                        персональными данными, включая сбор, запись, систематизацию,
                        накопление, хранение, уточнение (обновление, изменение), извлечение,
                        использование, передачу (распространение, предоставление, доступ),
                        обезличивание, блокирование, удаление, уничтожение персональных
                        данных.
                    </li>
                    <li>
                        Оператор — государственный орган, муниципальный орган, юридическое
                        или физическое лицо, самостоятельно или совместно с другими лицами
                        организующие и/или осуществляющие обработку персональных данных, а
                        также определяющие цели обработки персональных данных, состав
                        персональных данных, подлежащих обработке, действия (операции),
                        совершаемые с персональными данными.
                    </li>
                    <li>
                        Персональные данные — любая информация, относящаяся прямо или
                        косвенно к определенному или определяемому Пользователю веб-сайта{' '}
                        <a target="_blank" href="https://neuroplai.ru">
                            https://neuroplai.ru
                        </a>{' '}
                        .
                    </li>
                    <li>
                        Персональные данные, разрешенные субъектом персональных данных для
                        распространения, — персональные данные, доступ неограниченного круга
                        лиц к которым предоставлен субъектом персональных данных путем дачи
                        согласия на обработку персональных данных, разрешенных субъектом
                        персональных данных для распространения в порядке, предусмотренном
                        Законом о персональных данных (далее — персональные данные,
                        разрешенные для распространения).
                    </li>
                    <li>
                        Пользователь — любой посетитель веб-сайта{' '}
                        <a target="_blank" href="https://neuroplai.ru">
                            https://neuroplai.ru
                        </a>{' '}
                        .
                    </li>
                    <li>
                        Предоставление персональных данных — действия, направленные на
                        раскрытие персональных данных определенному лицу или определенному
                        кругу лиц.
                    </li>
                    <li>
                        Распространение персональных данных — любые действия, направленные
                        на раскрытие персональных данных неопределенному кругу лиц (передача
                        персональных данных) или на ознакомление с персональными данными
                        неограниченного круга лиц, в том числе обнародование персональных
                        данных в средствах массовой информации, размещение в
                        информационно-телекоммуникационных сетях или предоставление доступа
                        к персональным данным каким-либо иным способом.
                    </li>
                    <li>
                        Трансграничная передача персональных данных — передача персональных
                        данных на территорию иностранного государства органу власти
                        иностранного государства, иностранному физическому или иностранному
                        юридическому лицу.
                    </li>
                    <li>
                        Уничтожение персональных данных — любые действия, в результате
                        которых персональные данные уничтожаются безвозвратно с
                        невозможностью дальнейшего восстановления содержания персональных
                        данных в информационной системе персональных данных и/или
                        уничтожаются материальные носители персональных данных.
                    </li>
                </ol>
                <br />
                <li>Основные права и обязанности Оператора</li>
                <br />
                <ol>
                    <li>Оператор имеет право:</li>
                    <ol>
                        <li>
                            получать от субъекта персональных данных достоверные информацию
                            и/или документы, содержащие персональные данные;
                        </li>
                        <li>
                            в случае отзыва субъектом персональных данных согласия на
                            обработку персональных данных, а также, направления обращения с
                            требованием о прекращении обработки персональных данных, Оператор
                            вправе продолжить обработку персональных данных без согласия
                            субъекта персональных данных при наличии оснований, указанных в
                            Законе о персональных данных;
                        </li>
                        <li>
                            самостоятельно определять состав и перечень мер, необходимых и
                            достаточных для обеспечения выполнения обязанностей,
                            предусмотренных Законом о персональных данных и принятыми в
                            соответствии с ним нормативными правовыми актами, если иное не
                            предусмотрено Законом о персональных данных или другими
                            федеральными законами.
                        </li>
                    </ol>
                    <li>Оператор обязан:</li>
                    <ol>
                        <li>
                            предоставлять субъекту персональных данных по его просьбе
                            информацию, касающуюся обработки его персональных данных;
                        </li>
                        <li>
                            организовывать обработку персональных данных в порядке,
                            установленном действующим законодательством РФ;
                        </li>
                        <li>
                            отвечать на обращения и запросы субъектов персональных данных и их
                            законных представителей в соответствии с требованиями Закона о
                            персональных данных;
                        </li>
                        <li>
                            сообщать в уполномоченный орган по защите прав субъектов
                            персональных данных по запросу этого органа необходимую информацию
                            в течение 10 дней с даты получения такого запроса;
                        </li>
                        <li>
                            публиковать или иным образом обеспечивать неограниченный доступ к
                            настоящей Политике в отношении обработки персональных данных;
                        </li>
                        <li>
                            принимать правовые, организационные и технические меры для защиты
                            персональных данных от неправомерного или случайного доступа к
                            ним, уничтожения, изменения, блокирования, копирования,
                            предоставления, распространения персональных данных, а также от
                            иных неправомерных действий в отношении персональных данных;
                        </li>
                        <li>
                            прекратить передачу (распространение, предоставление, доступ)
                            персональных данных, прекратить обработку и уничтожить
                            персональные данные в порядке и случаях, предусмотренных Законом о
                            персональных данных;
                        </li>
                        <li>
                            исполнять иные обязанности, предусмотренные Законом о персональных
                            данных.
                        </li>
                    </ol>
                </ol>
                <br />
                <li>Основные права и обязанности субъектов персональных данных</li>
                <br />
                <ol>
                    <li>Субъекты персональных данных имеют право:</li>
                    <ol>
                        <li>
                            получать информацию, касающуюся обработки его персональных данных,
                            за исключением случаев, предусмотренных федеральными законами.
                            Сведения предоставляются субъекту персональных данных Оператором в
                            доступной форме, и в них не должны содержаться персональные
                            данные, относящиеся к другим субъектам персональных данных, за
                            исключением случаев, когда имеются законные основания для
                            раскрытия таких персональных данных. Перечень информации и порядок
                            ее получения установлен Законом о персональных данных;
                        </li>
                        <li>
                            требовать от оператора уточнения его персональных данных, их
                            блокирования или уничтожения в случае, если персональные данные
                            являются неполными, устаревшими, неточными, незаконно полученными
                            или не являются необходимыми для заявленной цели обработки, а
                            также принимать предусмотренные законом меры по защите своих прав;
                        </li>
                        <li>
                            выдвигать условие предварительного согласия при обработке
                            персональных данных в целях продвижения на рынке товаров, работ и
                            услуг;
                        </li>
                        <li>
                            на отзыв согласия на обработку персональных данных, а также, на
                            направление требования о прекращении обработки персональных
                            данных;
                        </li>
                        <li>
                            обжаловать в уполномоченный орган по защите прав субъектов
                            персональных данных или в судебном порядке неправомерные действия
                            или бездействие Оператора при обработке его персональных данных;
                        </li>
                        <li>
                            на осуществление иных прав, предусмотренных законодательством РФ.
                        </li>
                    </ol>
                    <li>Субъекты персональных данных обязаны:</li>
                    <ol>
                        <li>предоставлять Оператору достоверные данные о себе;</li>
                        <li>
                            сообщать Оператору об уточнении (обновлении, изменении) своих
                            персональных данных.
                        </li>
                    </ol>
                    <li>
                        Лица, передавшие Оператору недостоверные сведения о себе, либо
                        сведения о другом субъекте персональных данных без согласия
                        последнего, несут ответственность в соответствии с законодательством
                        РФ.
                    </li>
                </ol>
                <br />
                <li>Принципы обработки персональных данных</li>
                <br />
                <ol>
                    <li>
                        Обработка персональных данных осуществляется на законной и
                        справедливой основе.
                    </li>
                    <li>
                        Обработка персональных данных ограничивается достижением конкретных,
                        заранее определенных и законных целей. Не допускается обработка
                        персональных данных, несовместимая с целями сбора персональных
                        данных.
                    </li>
                    <li>
                        Не допускается объединение баз данных, содержащих персональные
                        данные, обработка которых осуществляется в целях, несовместимых
                        между собой.
                    </li>
                    <li>
                        Обработке подлежат только персональные данные, которые отвечают
                        целям их обработки.
                    </li>
                    <li>
                        Содержание и объем обрабатываемых персональных данных соответствуют
                        заявленным целям обработки. Не допускается избыточность
                        обрабатываемых персональных данных по отношению к заявленным целям
                        их обработки.
                    </li>
                    <li>
                        При обработке персональных данных обеспечивается точность
                        персональных данных, их достаточность, а в необходимых случаях и
                        актуальность по отношению к целям обработки персональных данных.
                        Оператор принимает необходимые меры и/или обеспечивает их принятие
                        по удалению или уточнению неполных или неточных данных.
                    </li>
                    <li>
                        Хранение персональных данных осуществляется в форме, позволяющей
                        определить субъекта персональных данных, не дольше, чем этого
                        требуют цели обработки персональных данных, если срок хранения
                        персональных данных не установлен федеральным законом, договором,
                        стороной которого, выгодоприобретателем или поручителем, по которому
                        является субъект персональных данных. Обрабатываемые персональные
                        данные уничтожаются либо обезличиваются по достижении целей
                        обработки или в случае утраты необходимости в достижении этих целей,
                        если иное не предусмотрено федеральным законом.
                    </li>
                </ol>
                <br />
                <li>Цели обработки персональных данных</li>
                <br />
                <ol>
                    <li>Цель обработки:</li>
                    <ol>
                        <li>
                            предоставление доступа Пользователю к сервисам, информации и/или
                            материалам, содержащимся на веб-сайте.
                        </li>
                    </ol>
                    <li>Персональные данные:</li>
                    <ol>
                        <li>фамилия, имя, отчество;</li>
                        <li>электронный адрес;</li>
                        <li>номера телефонов;</li>
                        <li>год, месяц, дата и место рождения;</li>
                        <li>фотографии;</li>
                    </ol>
                    <li>Правовые основания:</li>
                    <ol>
                        <li>
                            Федеральный закон «Об информации, информационных технологиях и о
                            защите информации» от 27.07.2006 N 149-ФЗ
                        </li>
                    </ol>
                    <li>Виды обработки персональных данных:</li>
                    <ol>
                        <li>
                            Сбор, запись, систематизация, накопление, хранение, уничтожение и
                            обезличивание персональных данных
                        </li>
                        <li>Отправка информационных писем на адрес электронной почты</li>
                    </ol>
                </ol>
                <br />
                <li>Условия обработки персональных данных</li>
                <br />
                <ol>
                    <li>
                        Обработка персональных данных осуществляется с согласия субъекта
                        персональных данных на обработку его персональных данных.
                    </li>
                    <li>
                        Обработка персональных данных необходима для достижения целей,
                        предусмотренных международным договором Российской Федерации или
                        законом, для осуществления возложенных законодательством Российской
                        Федерации на оператора функций, полномочий и обязанностей.
                    </li>
                    <li>
                        Обработка персональных данных необходима для осуществления
                        правосудия, исполнения судебного акта, акта другого органа или
                        должностного лица, подлежащих исполнению в соответствии с
                        законодательством Российской Федерации об исполнительном
                        производстве.
                    </li>
                    <li>
                        Обработка персональных данных необходима для исполнения договора,
                        стороной которого либо выгодоприобретателем или поручителем по
                        которому является субъект персональных данных, а также для
                        заключения договора по инициативе субъекта персональных данных или
                        договора, по которому субъект персональных данных будет являться
                        выгодоприобретателем или поручителем.
                    </li>
                    <li>
                        Обработка персональных данных необходима для осуществления прав и
                        законных интересов оператора или третьих лиц либо для достижения
                        общественно значимых целей при условии, что при этом не нарушаются
                        права и свободы субъекта персональных данных.
                    </li>
                    <li>
                        Осуществляется обработка персональных данных, доступ неограниченного
                        круга лиц к которым предоставлен субъектом персональных данных либо
                        по его просьбе (далее — общедоступные персональные данные).
                    </li>
                    <li>
                        Осуществляется обработка персональных данных, подлежащих
                        опубликованию или обязательному раскрытию в соответствии с
                        федеральным законом.
                    </li>
                </ol>
                <br />
                <li>
                    Порядок сбора, хранения, передачи и других видов обработки
                    персональных данных
                </li>
                <br />
                <ol>
                    <p>
                        Безопасность персональных данных, которые обрабатываются Оператором,
                        обеспечивается путем реализации правовых, организационных и
                        технических мер, необходимых для выполнения в полном объеме
                        требований действующего законодательства в области защиты
                        персональных данных.
                    </p>
                    <li>
                        Оператор обеспечивает сохранность персональных данных и принимает
                        все возможные меры, исключающие доступ к персональным данным
                        неуполномоченных лиц.
                    </li>
                    <li>
                        Персональные данные Пользователя никогда, ни при каких условиях не
                        будут переданы третьим лицам, за исключением случаев, связанных с
                        исполнением действующего законодательства либо в случае, если
                        субъектом персональных данных дано согласие Оператору на передачу
                        данных третьему лицу для исполнения обязательств по
                        гражданско-правовому договору.
                    </li>
                    <li>
                        В случае выявления неточностей в персональных данных, Пользователь
                        может актуализировать их самостоятельно, путем направления Оператору
                        уведомление на адрес электронной почты Оператора{' '}
                        <a target="_blank" href="mailto:Neiroseti@mail.ru">
                            Neiroseti@mail.ru
                        </a>{' '}
                        с пометкой «Актуализация персональных данных».
                    </li>
                    <li>
                        Срок обработки персональных данных определяется достижением целей,
                        для которых были собраны персональные данные, если иной срок не
                        предусмотрен договором или действующим законодательством.
                    </li>
                    <p>
                        Пользователь может в любой момент отозвать свое согласие на
                        обработку персональных данных, направив Оператору уведомление
                        посредством электронной почты на электронный адрес Оператора{' '}
                        <a target="_blank" href="mailto:Neiroseti@mail.ru">
                            Neiroseti@mail.ru
                        </a>{' '}
                        с пометкой «Отзыв согласия на обработку персональных данных».
                    </p>
                    <li>
                        Вся информация, которая собирается сторонними сервисами, в том числе
                        платежными системами, средствами связи и другими поставщиками услуг,
                        хранится и обрабатывается указанными лицами (Операторами) в
                        соответствии с их Пользовательским соглашением и Политикой
                        конфиденциальности. Субъект персональных данных и/или с указанными
                        документами. Оператор не несет ответственность за действия третьих
                        лиц, в том числе указанных в настоящем пункте поставщиков услуг.
                    </li>
                    <li>
                        Установленные субъектом персональных данных запреты на передачу
                        (кроме предоставления доступа), а также на обработку или условия
                        обработки (кроме получения доступа) персональных данных, разрешенных
                        для распространения, не действуют в случаях обработки персональных
                        данных в государственных, общественных и иных публичных интересах,
                        определенных законодательством РФ.
                    </li>
                    <li>
                        Оператор при обработке персональных данных обеспечивает
                        конфиденциальность персональных данных.
                    </li>
                    <li>
                        Оператор осуществляет хранение персональных данных в форме,
                        позволяющей определить субъекта персональных данных, не дольше, чем
                        этого требуют цели обработки персональных данных, если срок хранения
                        персональных данных не установлен федеральным законом, договором,
                        стороной которого, выгодоприобретателем или поручителем по которому
                        является субъект персональных данных.
                    </li>
                    <li>
                        Условием прекращения обработки персональных данных может являться
                        достижение целей обработки персональных данных, истечение срока
                        действия согласия субъекта персональных данных, отзыв согласия
                        субъектом персональных данных или требование о прекращении обработки
                        персональных данных, а также выявление неправомерной обработки
                        персональных данных.
                    </li>
                </ol>
                <br />
                <li>
                    Перечень действий, производимых Оператором с полученными персональными
                    данными
                </li>
                <br />
                <ol>
                    <li>
                        Оператор осуществляет сбор, запись, систематизацию, накопление,
                        хранение, уточнение (обновление, изменение), извлечение,
                        использование, передачу (распространение, предоставление, доступ),
                        обезличивание, блокирование, удаление и уничтожение персональных
                        данных.
                    </li>
                    <li>
                        Оператор осуществляет автоматизированную обработку персональных
                        данных с получением и/или передачей полученной информации по
                        информационно-телекоммуникационным сетям или без таковой.
                    </li>
                </ol>
                <br />
                <li>Трансграничная передача персональных данных</li>
                <br />
                <ol>
                    <li>
                        Оператор до начала осуществления деятельности по трансграничной
                        передаче персональных данных обязан уведомить уполномоченный орган
                        по защите прав субъектов персональных данных о своем намерении
                        осуществлять трансграничную передачу персональных данных (такое
                        уведомление направляется отдельно от уведомления о намерении
                        осуществлять обработку персональных данных).
                    </li>
                    <li>
                        Оператор до подачи вышеуказанного уведомления, обязан получить от
                        органов власти иностранного государства, иностранных физических лиц,
                        иностранных юридических лиц, которым планируется трансграничная
                        передача персональных данных, соответствующие сведения.
                    </li>
                </ol>
                <br />
                <li>Конфиденциальность персональных данных</li>
                <br />
                <ol>
                    <li>
                        Оператор и иные лица, получившие доступ к персональным данным,
                        обязаны не раскрывать третьим лицам и не распространять персональные
                        данные без согласия субъекта персональных данных, если иное не
                        предусмотрено федеральным законом.
                    </li>
                </ol>
                <br />
                <li>Заключительные положения</li>
                <br />
                <ol>
                    <li>
                        Пользователь может получить любые разъяснения по интересующим
                        вопросам, касающимся обработки его персональных данных, обратившись
                        к Оператору с помощью электронной почты{' '}
                        <a target="_blank" href="mailto:Neiroseti@mail.ru">
                            Neiroseti@mail.ru
                        </a>{' '}
                    </li>
                    <li>
                        В данном документе будут отражены любые изменения политики обработки
                        персональных данных Оператором. Политика действует бессрочно до
                        замены ее новой версией.
                    </li>
                    <li>
                        Актуальная версия Политики в свободном доступе расположена в сети
                        Интернет по адресу{' '}
                        <a target="_blank" href="https://neuroplai.ru">
                            Neiroseti@mail.ru
                        </a>
                    </li>
                </ol>
            </ol>
        </Wrapper>
    );
};
